import React, { useCallback, useEffect, useState, useRef } from "react";
import "~/assets/css/styles.css";
import "~/assets/css/icons.css";
import "../../RhCollaborator/RhCollaborator.scss";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {
  Search,
  CSVExport,
  PrintContextConsumer,
} from "react-bootstrap-table2-toolkit";
import { useSelector, useDispatch } from "react-redux";
import {
  getCollaborators,
  getConsumoSaldo,
  getMarcacaoFerias,
  getAllMarcacaoFerias,
  postMarcacaoFerias,
  cancelDayOffRequest,
  setUpdateVacations,
  approveDeleteRemoveMarcacaoFerias,
  setMarcacaoFerias,
  postExportVacations,
  setExportVacations,
  cleanIsLoading,
  getEventEntrieDetail,
  setEventEntrieDetail,
} from "~/store/ducks/portalrh/actionTypes";
import InputLabel from "@mui/material/InputLabel";
import { v4 as uuidv4 } from "uuid";
import { withNamespaces } from "react-i18next";
import DatePicker from "~/components/DatePicker";
import {
  Button as ButtonBoot,
  Row,
  Col,
  Form,
  Modal,
  ListGroup,
  Table,
  Alert,
} from "react-bootstrap";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./styles.css";
import "~/assets/css/scheduler.css";
import { Dropdown as DropDownBoot } from "react-bootstrap";
import DropdownButton from "react-bootstrap/DropdownButton";
import moment from "moment";
import { navigate } from "./ColorVariables";
import SpinnerNew from "~/components/SpinnerNew";
import { Button, Stack, Tabs, Tab } from "@mui/material";
import { grey } from "@mui/material/colors";
import { TextField } from "@material-ui/core";
import { styled } from "@mui/material/styles";
import {
  FaCalendarDay,
  FaCalendarAlt,
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaTrash,
  FaClock,
  FaCheckCircle,
  FaMinusCircle,
  FaTimesCircle,
  FaEye,
  FaFileExport,
} from "react-icons/fa";
import {
  MdExpandMore,
  MdExpandLess,
  MdOutlineRemoveCircleOutline,
} from "react-icons/md";
import { CgCalendarToday } from "react-icons/cg";
import { HiMiniCalendarDays } from "react-icons/hi2";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
  setErrorPostMarcacaoFeriasConfirm,
  setExportVals,
} from "~/store/ducks/portalrh/actionTypes";
import { GoPlusCircle, GoTrash } from "react-icons/go";
import Year from "./Year";

import uuid from "uuid/v1";

import { Popover } from "@material-ui/core";

import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Situation from "./Situation";
import { handlePrint } from "~/utils";
import CalendarReact from "react-calendar";
import {
  convertToEvents,
  convertToEventsFolgas,
  convertToEventsDiasMarcados,
  convertToEventsDiasGozados,
  convertToEventsDiasPendentes,
  convertToEventsDiasMarcadosTeamEmployee,
  convertToEventsDiasMarcadosTeam,
  convertToEventsMarkedDays,
  convertToEventsMarkedDaysToApprove,
  getMonthRange,
  isDisabled,
  generateCalendarData,
  eventosDoDia,
  getEventsToCreate,
} from "./utils";
import "react-calendar/dist/Calendar.css";
import Modals from "./Modals";
import ExportTable from "./ExportTable";
import AlertsComponent from "./AlertsComponent";

const SchedulerComponent = ({
  portalRhMenus,
  designacao,
  path,
  t,
  isEditable,
  showCalendarAndTable = true,
  loadEventsStart,
  setLoadEventsStart,
  selectedUser,
  setSelectedUser,
  grupos,
  setgrupos,
  activeButton,
  setActiveButton,
  hideChangeView,
  infoDataWorkHour,
  dataSelectedRequest,
  showAllGroups = false,
  exportBtn,
  diasParaAprovar,
  infoTypeRequest = "",
  infoEmployee = "",
  styleSheet,
}) => {
  const { user } = useSelector((state) => state.globalReducer);
  const { userSettings } = useSelector((state) => state.userSettingsReducer);
  const { configuration } = useSelector((state) => state.adminConfigReducer);
  const { iflowpid } = useSelector((state) => state.processesReducer);
  const { rhbolsaHorasConfiguration } = useSelector(
    (state) => state.rhadminConfigurationReducer
  );
  const {
    collaborators,
    marcacaoFerias,
    allMarcacaoFeriasMonth,
    isLoadingMarcacaoFerias,
    marcacaoFeriasmsg,
    marcacaoFeriasmsgConfirm,
    gruposTrabalhoRemoto,
    trabalhoRemotoInfoSaldo,
    exportMsg,
    isLoadingExport,
    marcacaoFeriasCalendario,
    consumoSaldo,
    exportVacations,
    isToUpdateVacations,
    eventEntrieDetail,
    isloadingEntrieDetail,
  } = useSelector((state) => state.portalrhReducer);
  const { rhbolsaHorasUsersGroup } = useSelector(
    (state) => state.rhadminConfigurationReducer
  );

  const { organization } = useSelector((state) => state.organizationsReducer);

  const [menuSideBar, setMenuSideBar] = useState(null);
  const [selectedLocale, setSelectedLocale] = useState(
    userSettings && userSettings.language ? userSettings.language.trim() : "en"
  );
  const [forceUpdate, setForceUpdate] = useState(0);
  const [events, setEvents] = useState([]);
  const [localizer, setLocalizer] = useState(momentLocalizer(moment));
  const [dateSelected, setDateSelected] = useState(new Date());
  const [loadNewDateSelected, setLoadNewDateSelected] = useState(new Date());
  const [workdays_hours, setworkdays_hours] = useState({});
  const [defaultView, setDefaultView] = useState("year");
  const [showToast, setShowToast] = useState(false);
  const [showToastMSG, setShowToastMSG] = useState(false);
  const [toastText, settoastText] = useState("");
  const [showModalWithDaysMarked, setShowModalWithDaysMarked] = useState(false);
  const [showModalWithDaysMarkedConfirm, setShowModalWithDaysMarkedConfirm] =
    useState(false);

  const [isTabsVisible, setIsTabsVisible] = useState(true);

  const [openExport, setOpenExport] = useState(false);
  const [messageTranslated, setmessageTranslated] = useState("");
  const [openExportError, setOpenExportError] = useState(false);
  const [rangesState, setrangesState] = useState({});

  const [selectedGroup, setSelectedGroup] = useState([]);
  const [criteriaGroup, setCriteriaGroup] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedUsersColor, setSelectedUsersColor] = useState({});
  const [searchFilter, setSearchFilter] = useState("");
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectAll, setSelectAll] = useState(showAllGroups);
  const [displayedUsers, setDisplayedUsers] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [popupEvent, setPopupEvent] = useState(null);

  const [showModalCheckDays, setShowModalCheckDays] = useState(false);
  const [showModalCriteria, setShowModalCriteria] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [removeall, setRemoveAll] = useState(false);
  const [removeSomeDays, setRemoveSomeDays] = useState({});
  const [blockIntervalSelections, setBlockIntervalSelections] = useState(false);
  const [showModalWithDaysToRemove, setShowModalWithDaysToRemove] =
    useState(false);
  const [dateToCompare, setDateToCompare] = useState(undefined);
  const [singleDaySelection, setSingleDaySelection] = useState("single");
  const [confirmRemoveDaysSelected, setConfirmRemoveDaysSelected] =
    useState(false);

  const [endAt, setEndAt] = useState("");
  const [startAt, setStartAt] = useState("");
  const [starEndtMonth, setstarEndtMonth] = useState({
    start: "",
    end: "",
  });
  const [showDropdown, setShowDropdown] = useState(false);
  const [showAllList, setShowAllList] = useState(true);

  const [eventsTemp, setEventsTemp] = useState([]);
  const [emplyeeEvents, setEmplyeeEvents] = useState([]);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < 768 && configuration && configuration.mobileReady
  );
  const [load, setLoad] = useState(false);

  const [showCalendar, setShowCalendar] = useState(false);

  const [personName, setPersonName] = useState([]);
  const [userNamePortalRH, setUserNamePortalRH] = useState(undefined);

  const [tableType, setTableType] = useState(false);
  const [calendarData, setCalendarData] = useState([]);
  const componentRef = useRef();
  const allUsers = selectedGroup.length
    ? gruposTrabalhoRemoto
        .filter(({ grupo }) => selectedGroup.includes(grupo.id))
        .flatMap(({ userList }) => userList)
    : displayedUsers;

  const filteredUsers = allUsers.filter(({ nomeCurto }) =>
    nomeCurto?.toLowerCase().includes(searchFilter?.toLowerCase())
  );

  const displayedUsersList =
    selectedTab === 0
      ? filteredUsers
      : selectedGroup.length
      ? allUsers.filter(({ numFuncionario }) =>
          selectedUsers.includes(numFuncionario)
        )
      : allUsers;

  const handleDateChange = (newDate) => {
    setDateSelected(newDate);
    setShowCalendar(false);
    getDatesFromDays(newDate);
  };

  const open = Boolean(anchorEl);

  const [key, setKey] = useState(designacao);

  const dispatch = useDispatch();

  useEffect(() => {
    const usernamePortal = collaborators.find((collaborator) => {
      const matchingLegacyUser = user.legacyUsers.find(
        (legacyUser) =>
          legacyUser.username === collaborator.username &&
          legacyUser.legacyApplication.label === "portalrh"
      );
      return matchingLegacyUser;
    });
    setUserNamePortalRH(usernamePortal);
  }, [collaborators, user]);

  useEffect(() => {
    if (diasParaAprovar && diasParaAprovar.dates.length > 0) {
      const firstDate = new Date(diasParaAprovar.dates[0]);
      setDateSelected(firstDate);
    }
  }, [diasParaAprovar]);

  useEffect(() => {
    const handleResize = () =>
      setIsMobile(
        window.innerWidth < 768 && configuration && configuration.mobileReady
      );
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) setIsTabsVisible(false);
  }, [isMobile]);

  useEffect(() => {
    if (Object.keys(removeSomeDays).length > 0) {
      const eventsDays = events.filter(
        (event) => event.idToSelect === removeSomeDays.idToSelect
      );
      setEventsTemp(eventsDays);
      setShowModalWithDaysToRemove(true);
      setDateToCompare(removeSomeDays.start);
    }
  }, [removeSomeDays]);

  useEffect(() => {
    if (Object.keys(exportVacations).length > 0) {
      const data = generateCalendarData(exportVacations, loadNewDateSelected);
      setCalendarData(data);
      dispatch(setExportVacations({}));
    }
  }, [exportVacations]);

  useEffect(() => {
    if (calendarData.length > 0) {
      handlePrint(componentRef.current, setLoad, true);
      dispatch(cleanIsLoading());
    }
  }, [calendarData]);

  useEffect(() => {
    dispatch(setMarcacaoFerias({}));
    setEvents([]);
    setShowToastMSG(false);
    setOpenExport(false);
    setmessageTranslated("");
    setOpenExportError(false);
    setShowModalWithDaysMarked(false);
    setShowModalWithDaysMarkedConfirm(false);
    setDisplayedUsers([]);
    setEmplyeeEvents([]);
    const { start, end } = getMonthRange(dateSelected);
    rangeChange({ start, end });
    setstarEndtMonth({
      start: moment(dateSelected).startOf("month").startOf("week"),
      end: moment(dateSelected).endOf("month").endOf("week"),
    });
    dispatch(getCollaborators());
    dispatch(getConsumoSaldo());
    const menu = portalRhMenus.find((menu) => menu.designacao === designacao);
    if (menu) setMenuSideBar(menu);
  }, []);

  useEffect(() => {
    if (defaultView === "month") {
      setSingleDaySelection("single");
      setBlockIntervalSelections(true);
    } else {
      setBlockIntervalSelections(false);
    }
  }, [defaultView]);

  useEffect(() => {
    if (isEditable) {
      if (userNamePortalRH !== undefined) callUpdateMarcacaoFerias();
    }
  }, [isEditable, userNamePortalRH]);

  useEffect(() => {
    const eventsDays =
      events &&
      events.filter(
        (event) =>
          event.type === "feriasmarked" ||
          event.type === "hover" ||
          event.type === "intervals"
      );
    setRemoveAll(eventsDays && eventsDays.length > 0);
  }, [events]);

  useEffect(() => {
    if (exportMsg !== "") {
      let messagetrans;
      if (exportMsg === "exportedScreen") {
        messagetrans = t("portalrh.workDays.export.exportedScreen");
      } else if (exportMsg === "exportedCriteria") {
        messagetrans = t("portalrh.workDays.export.exportedCriteria");
      }
      if (exportMsg.includes("exportedYear")) {
        let splited = exportMsg.split("::");
        messagetrans =
          t(`portalrh.workDays.export.${splited[0]}`) + "_" + splited[1];
      }
      setmessageTranslated(messagetrans);
      setOpenExport(true);
    }
  }, [exportMsg]);

  useEffect(() => {
    if (!gruposTrabalhoRemoto.length) return;

    if (infoDataWorkHour !== undefined) {
      const grupo = gruposTrabalhoRemoto.find(({ userList }) =>
        userList.some(({ id }) => id === infoDataWorkHour)
      );
      if (grupo) {
        setShowAllList(false);
        setSelectedGroup([grupo.grupo.id]);
        setSelectedUsers(
          grupo.userList.map(({ numFuncionario }) => numFuncionario)
        );
      }
    } else if (!selectedGroup.length) {
      const allUsers = gruposTrabalhoRemoto.flatMap(({ userList }) => userList);
      const hideUsers = styleSheet?.hideUsersVacation;
      setDisplayedUsers(allUsers);
      setSelectedUsers(
        hideUsers ? [] : allUsers.map(({ numFuncionario }) => numFuncionario)
      );
      setSelectAll(!hideUsers);
    }

    if (dataSelectedRequest?.length) {
      getDatesFromDays(new Date(dataSelectedRequest[0].data));
    }
  }, [gruposTrabalhoRemoto, infoDataWorkHour]);

  const updateMarcacaoFerias = (data, users) => {
    callUpdateMarcacaoFerias(data, users);
  };

  useEffect(() => {
    if (
      userNamePortalRH !== undefined &&
      dateToCompare === undefined &&
      isToUpdateVacations
    ) {
      updateMarcacaoFerias();
      dispatch(setUpdateVacations(false));
    }
  }, [isToUpdateVacations]);

  const callUpdateMarcacaoFerias = (data = loadNewDateSelected, users) => {
    const year = data.getFullYear() ?? loadNewDateSelected.getFullYear();
    const month = dateSelected.getMonth();
    const firstDayOfYear = moment(data ?? loadNewDateSelected)
      .startOf("year")
      .format("YYYY-MM-DD");
    const lastDayOfYear = moment(data ?? loadNewDateSelected)
      .endOf("year")
      .format("YYYY-MM-DD");

    const payload = {
      usrId: userNamePortalRH?.id,
      entidade: userNamePortalRH?.codEntidade,
      numFunc: userNamePortalRH?.funcionarioNum,
      ano: year,
    };

    if (isEditable) {
      dispatch(getMarcacaoFerias(payload));
    } else {
      const lepNums =
        selectedGroup.length > 0
          ? selectedGroup.flatMap(
              (groupId) =>
                gruposTrabalhoRemoto
                  .find((group) => group.grupo.id === groupId)
                  ?.userList.map((user) => user.numFuncionario) || []
            )
          : displayedUsers.map((user) => user.numFuncionario);

      dispatch(
        getAllMarcacaoFerias({
          lepNum: users?.length > 0 ? users : selectedUsers,
          ano: year,
          employee: infoEmployee,
          diaInicial: firstDayOfYear,
          diaFinal: lastDayOfYear,
        })
      );
    }
  };

  const handleGetExportVacations = (type) => {
    const year = loadNewDateSelected.getFullYear();
    const entidades = [];

    gruposTrabalhoRemoto.forEach((group) => {
      if (selectedGroup.includes(group.grupo.id)) {
        group.userList.forEach((user) => {
          if (selectedUsers.includes(user.numFuncionario)) {
            entidades.push({
              entidade: user.empCode,
              numeroFuncionario: user.numFuncionario,
            });
          }
        });
      }
    });

    const payload = {
      ano: year,
      funcionarioDTO: entidades,
      feriasPendentes: type,
    };
    setTableType(type);
    dispatch(postExportVacations(payload));
  };

  useEffect(() => {
    setForceUpdate((prevKey) => prevKey + 1);
    setworkdays_hours(
      Object.keys(marcacaoFerias).length > 0 ? marcacaoFerias : {}
    );
  }, [marcacaoFerias]);

  useEffect(() => {
    const supportedLanguages = ["es", "pt"];
    if (userSettings) {
      const locale = supportedLanguages.includes(selectedLocale)
        ? selectedLocale
        : "en";
      require(`moment/locale/${locale}.js`);
      moment.locale(locale);
      moment.updateLocale(locale, { week: { dow: 0 } });
      setLocalizer(momentLocalizer(moment));
      setSelectedLocale(userSettings.language.trim());
    }
  }, [userSettings.language, selectedLocale, workdays_hours]);

  useEffect(() => {
    if (Object.keys(marcacaoFeriasmsg).length > 0) {
      setShowModalWithDaysMarkedConfirm(true);
      setShowModalWithDaysMarked(false);
    } else {
      setShowModalWithDaysMarkedConfirm(false);
      setShowModalWithDaysMarked(false);
    }
  }, [marcacaoFeriasmsg]);

  useEffect(() => {
    if (marcacaoFeriasmsgConfirm !== "") {
      setShowToastMSG(true);
      settoastText(marcacaoFeriasmsgConfirm);
      callUpdateMarcacaoFerias();
    } else {
      setShowToastMSG(false);
      settoastText("");
    }
  }, [marcacaoFeriasmsgConfirm]);

  const handleCloseShowToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setShowToast(false);
    settoastText("");
  };

  const handleCloseShowToastMSG = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(setErrorPostMarcacaoFeriasConfirm(""));
    setShowToastMSG(false);
    settoastText("");
  };

  localizer.formats.yearHeaderFormat = "YYYY";

  useEffect(() => {
    const updateEvents = () => {
      if (Object.keys(workdays_hours).length > 0) {
        const events = [
          ...convertToEvents(
            t,
            workdays_hours?.feriados,
            "feriados",
            "rgb(226, 226, 226)"
          ),
          ...convertToEventsFolgas(
            t,
            workdays_hours?.folgas,
            "folgas",
            "#D6D6D6"
          ),
          ...convertToEventsDiasMarcados(
            t,
            workdays_hours?.ferias,
            "ferias",
            "#4447A4",
            workdays_hours.marcacoes,
            true
          ),
          ...convertToEventsDiasMarcados(
            t,
            workdays_hours?.datasMarcacoes,
            "datasMarcacoes",
            "#188804",
            workdays_hours.marcacoes,
            true,
            workdays_hours.feriasPendentesMap
          ),
          ...convertToEventsDiasGozados(
            t,
            workdays_hours?.datasGozados,
            "datasGozados",
            "#C9FFCC",
            workdays_hours.marcacoes,
            true,
            workdays_hours.feriasPendentesMap
          ),
          ...convertToEventsDiasPendentes(
            t,
            workdays_hours?.feriasPendentes,
            "feriasPendentes",
            "#E6CD32",
            workdays_hours.feriasPendentesMap
          ),
          ...getDiasParaAprovarEvents(),
        ];
        setEvents(events);
      } else {
        setEvents([]);
      }
    };

    updateEvents();
  }, [workdays_hours, marcacaoFerias]);

  const getDiasParaAprovarEvents = () => {
    if (!diasParaAprovar) return [];
    const type =
      infoTypeRequest !== "Novo" ? "diasAprovarCancelar" : "diasAprovar";
    const color = infoTypeRequest !== "Novo" ? "#F8B4B4" : "rgb(255, 165, 0)";
    return convertToEventsMarkedDaysToApprove(t, diasParaAprovar, type, color);
  };

  useEffect(() => {
    if (!isEditable) {
      const events =
        selectedUsers.length > 0
          ? filterWorkdaysByUsers()
          : [...getDiasParaAprovarEvents(), ...emplyeeEvents];
      setEvents(events || []);
    }
  }, [selectedUsers, workdays_hours]);

  const handleModalCloseCheckDays = () => {
    setShowModalCheckDays(false);
    setSelectedSlot(null);
  };

  const handleModalCloseCriteria = () => {
    setShowModalCriteria(false);
    setCriteriaGroup("");
    setEndAt("");
    setStartAt("");
  };

  const confirmCheckDay = (slotInfo) => {
    const [newEvent] = convertToEventsMarkedDays(
      t,
      [slotInfo],
      "feriasmarked",
      "#E6CD32"
    );

    setEvents((prevEvents) => {
      const isAlreadyAdded = prevEvents.some(
        ({ type, start }) =>
          type === "feriasmarked" && moment(start).isSame(newEvent.start, "day")
      );

      return isAlreadyAdded
        ? (setRemoveAll(true),
          prevEvents.filter(
            ({ type, start }) =>
              !(
                type === "feriasmarked" &&
                moment(start).isSame(newEvent.start, "day")
              )
          ))
        : [...prevEvents, newEvent];
    });
  };

  const getDatesFromDays = (date) => {
    setDateSelected(date);
    const { start, end } = getMonthRange(date);
    rangeChange({ start, end });
    setstarEndtMonth({
      start: moment(date).startOf("month").startOf("week"),
      end: moment(date).endOf("month").endOf("week"),
    });
    if (date.getFullYear() !== loadNewDateSelected.getFullYear()) {
      setLoadNewDateSelected(date);
      updateMarcacaoFerias(date);
    }
    handleRestartMarkup();
  };

  const rangeChange = useCallback(
    (range) => {
      setrangesState(range);
      return {};
    },
    [events]
  );

  const dayPropGetter = useCallback(
    (date) => {
      const eventOnDate = events.find((event) =>
        moment(event.start).isSame(date, "day")
      );
      const { start, end } = getMonthRange(dateSelected);

      if (date < start || date > end) {
        return {
          style: {
            backgroundColor: "#F8F8F8",
            color: "#a0aec0",
            pointerEvents: "none",
          },
        };
      }

      if (eventOnDate) {
        const styles = {
          feriasPendentes: {
            backgroundColor: "transparent",
            color: "#666",
            pointerEvents: "none",
          },
          ferias: {
            backgroundColor: "transparent",
            color: "#666",
            pointerEvents: "none",
          },
          feriados: {
            backgroundColor: "rgb(226, 226, 226)",
            color: "#666",
            pointerEvents: "none",
          },
          folgas: {
            backgroundColor: "rgba(226, 226, 226,0.6)",
            color: "#666",
            pointerEvents: "none",
          },
          diasAprovar: {
            backgroundColor: "rgba(255, 165, 0, 0.5)",
            color: "#666",
            pointerEvents: "none",
          },
          diasAprovarCancelar: {
            backgroundColor: "#F8B4B4",
            color: "#666",
            pointerEvents: "none",
          },
        };

        return { style: styles[eventOnDate.type] || {} };
      }

      return {};
    },
    [events, defaultView]
  );

  const handleGroupChange = (groupId) => {
    let users = [];
    const hideUsers = styleSheet?.hideUsersVacation;

    if (groupId === "") {
      const isSelectingAll =
        selectedGroup.length !== gruposTrabalhoRemoto.length;
      const newGroups = isSelectingAll
        ? gruposTrabalhoRemoto.map((group) => group.grupo.id)
        : [];
      const newUsers = isSelectingAll
        ? gruposTrabalhoRemoto.flatMap((group) => group.userList)
        : [];

      setSelectAll(!hideUsers && isSelectingAll);
      setSelectedGroup(newGroups);
      setDisplayedUsers(newUsers);
      setSelectedUsers(
        !hideUsers ? newUsers.map((user) => user.numFuncionario) : []
      );
      users = !hideUsers ? newUsers.map((user) => user.numFuncionario) : [];
    } else {
      const isGroupSelected = selectedGroup.includes(groupId);
      const newSelectedGroups = isGroupSelected
        ? selectedGroup.filter((id) => id !== groupId)
        : [...selectedGroup, groupId];
      const newUsers = gruposTrabalhoRemoto
        .filter((group) => newSelectedGroups.includes(group.grupo.id))
        .flatMap((group) => group.userList);

      setSelectAll(!hideUsers && isGroupSelected);
      setSelectedGroup(newSelectedGroups);
      setDisplayedUsers(newUsers);
      setSelectedUsers(
        !hideUsers ? newUsers.map((user) => user.numFuncionario) : []
      );
      users = !hideUsers ? newUsers.map((user) => user.numFuncionario) : [];
    }

    updateMarcacaoFerias(undefined, users);
    setSelectedTab(0);
    setShowAllList(false);
  };

  const handleUserChange = (userId) => {
    let users = [];
    if (userId === "selectAll") {
      const allUserIds = displayedUsersList.map((user) => user.numFuncionario);
      users = selectAll ? [] : allUserIds;
      setSelectedUsers(users);
      setSelectAll(!selectAll);
    } else {
      const updatedSelectedUsers = selectedUsers.includes(userId)
        ? selectedUsers.filter((id) => id !== userId)
        : [...selectedUsers, userId];
      users = updatedSelectedUsers;
      setSelectedUsers(users);
      setSelectAll(false);
    }
    updateMarcacaoFerias(undefined, users);
  };

  const filterWorkdaysByUsers = (view = defaultView) => {
    if (!workdays_hours?.diasmarcadosTeam) return;

    const filterDiasMarcados = (diasMarcados) =>
      infoEmployee !== ""
        ? diasMarcados.userId !== infoEmployee &&
          selectedUsers.includes(diasMarcados.userId)
        : diasMarcados;

    const filteredDiasMarcadosTeam =
      workdays_hours.diasmarcadosTeam.filter(filterDiasMarcados);
    const filteredDiasMarcadosMonthTeam =
      workdays_hours.diasMarcadosMonth.filter(filterDiasMarcados);

    const updatedSelectedUsersColor = (
      view === "year"
        ? infoEmployee !== ""
          ? filteredDiasMarcadosMonthTeam
          : filteredDiasMarcadosTeam
        : filteredDiasMarcadosMonthTeam
    ).reduce(
      (acc, { userId, color }) => {
        acc[userId] = color;
        return acc;
      },
      selectedUsers.reduce((acc, userId) => {
        acc[userId] = "#007bff";
        return acc;
      }, {})
    );

    setSelectedUsersColor(updatedSelectedUsersColor);

    const convertEventsTeam = (diasMarcados, type) =>
      convertToEventsDiasMarcadosTeam(t, diasMarcados, type);
    const diasMarcadosTeamEvents = convertEventsTeam(
      filteredDiasMarcadosTeam,
      "ferias"
    );
    const diasMarcadosTeamMonthEvents = convertEventsTeam(
      filteredDiasMarcadosMonthTeam,
      "ferias"
    );

    const diasMarcadosTeamPessoaEvents = diasParaAprovar
      ? convertToEventsDiasMarcadosTeamEmployee(
          t,
          workdays_hours.diasMarcadosMonth.filter(
            (diasMarcados) =>
              infoEmployee !== "" && diasMarcados.userId === infoEmployee
          ),
          "ferias"
        )
      : [];

    const diasParaAprovarEvent = diasParaAprovar
      ? convertToEventsMarkedDaysToApprove(
          t,
          diasParaAprovar,
          infoTypeRequest !== "Novo" ? "diasAprovarCancelar" : "diasAprovar",
          infoTypeRequest !== "Novo" ? "#F8B4B4" : "rgb(255, 165, 0)"
        )
      : [];

    setEmplyeeEvents(diasMarcadosTeamPessoaEvents);

    return view === "year"
      ? infoEmployee !== ""
        ? [
            ...diasMarcadosTeamMonthEvents,
            ...diasMarcadosTeamPessoaEvents,
            ...diasParaAprovarEvent,
          ]
        : [
            ...diasMarcadosTeamEvents,
            ...diasMarcadosTeamPessoaEvents,
            ...diasParaAprovarEvent,
          ]
      : [
          ...diasMarcadosTeamMonthEvents,
          ...diasMarcadosTeamPessoaEvents,
          ...diasParaAprovarEvent,
        ];
  };

  const handleSearchChange = (event) => {
    setSearchFilter(event.target.value);
    setSelectedTab(0);
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const toggleTabsVisibility = () => {
    setIsTabsVisible(!isTabsVisible);
  };

  const listUsersByGroupConstructor = () => {
    if (selectedGroup.length === 0 && showAllList) {
      handleGroupChange("");
    }
    return (
      <div>
        <FormControl sx={{ m: 1, width: "-webkit-fill-available" }}>
          <Row>
            <Col
              md="12"
              lg="7"
              sm="12"
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "1rem",
              }}
            >
              <DropDownBoot
                show={showDropdown}
                onToggle={() => setShowDropdown(!showDropdown)}
              >
                <DropDownBoot.Toggle
                  id="dropdown-basic"
                  style={{ width: "auto" }}
                >
                  {selectedGroup.length === 0
                    ? t("portalrh.workDays.selectAnGroup")
                    : selectedGroup.length === 1
                    ? (() => {
                        const designacao = gruposTrabalhoRemoto.find(
                          (group) => group.grupo.id === selectedGroup[0]
                        ).grupo.designacao;
                        return designacao.length > 30
                          ? `${designacao.substring(0, 30)}...`
                          : designacao;
                      })()
                    : `${selectedGroup.length} ${t(
                        "portalrh.workDays.selectedGroups"
                      )}`}
                </DropDownBoot.Toggle>

                <DropDownBoot.Menu style={{ minWidth: "300px" }}>
                  <Form>
                    <Form.Check
                      type="checkbox"
                      id={`check-all`}
                      label={t("portalrh.workDays.all")}
                      checked={
                        selectedGroup.length === gruposTrabalhoRemoto.length
                      }
                      onChange={() => handleGroupChange("")}
                      style={{ minWidth: "280px", margin: "10px" }}
                    />
                    {gruposTrabalhoRemoto.map((group) => (
                      <Form.Check
                        key={group.grupo.id}
                        type="checkbox"
                        id={`check-${group.grupo.id}`}
                        label={
                          group.grupo.designacao.length > 30
                            ? `${group.grupo.designacao.substring(0, 30)}...`
                            : group.grupo.designacao
                        }
                        checked={selectedGroup.includes(group.grupo.id)}
                        onChange={() => handleGroupChange(group.grupo.id)}
                        style={{ minWidth: "280px", margin: "10px" }}
                      />
                    ))}
                  </Form>
                </DropDownBoot.Menu>
              </DropDownBoot>
              <DropDownBoot>
                <DropDownBoot.Toggle id="dropdown-basicSelection">
                  {t("portalrh.abscenses.exportar")}
                </DropDownBoot.Toggle>

                <DropDownBoot.Menu>
                  <DropDownBoot.Item
                    onClick={() => handleGetExportVacations(false)}
                  >
                    {t("portalrh.abscenses.exportarApproved")}
                  </DropDownBoot.Item>
                  <DropDownBoot.Item
                    onClick={() => handleGetExportVacations(true)}
                  >
                    {t("portalrh.abscenses.exportarPending")}
                  </DropDownBoot.Item>
                </DropDownBoot.Menu>
              </DropDownBoot>
            </Col>
          </Row>

          <>
            {isMobile && (
              <div
                className="mobile-tabs-toggle"
                onClick={toggleTabsVisibility}
                style={{
                  display: "flex",
                  gap: "1rem",
                  alignItems: "center",
                  margin: "1rem 0px",
                }}
              >
                {isTabsVisible ? (
                  <MdExpandLess style={{ fontSize: "x-large" }} />
                ) : (
                  <MdExpandMore style={{ fontSize: "x-large" }} />
                )}
                {!isTabsVisible && <span>Colaboradores</span>}
              </div>
            )}
            {selectedGroup.length > 0 && isTabsVisible && (
              <Tabs
                value={selectedTab}
                onChange={handleTabChange}
                TabIndicatorProps={{
                  style: {
                    backgroundColor: "#4484f4",
                    color: "#4484f4",
                    borderRadius: "0px 0px 8px 0px",
                  },
                }}
              >
                <Tab label={t("portalrh.workDays.all")} />
                <Tab label={t("portalrh.workDays.selected")} />
              </Tabs>
            )}

            {selectedTab == 0 && isTabsVisible && (
              <>
                <TextField
                  label={t("portalrh.workDays.searchCol")}
                  variant="standard"
                  value={searchFilter}
                  onChange={handleSearchChange}
                  size="small"
                  style={{ margin: "10px 0px", width: "250px" }}
                />
                {searchFilter === "" && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectAll}
                        onChange={() => handleUserChange("selectAll")}
                      />
                    }
                    label={t("portalrh.workDays.selectAll")}
                  />
                )}
              </>
            )}
          </>
        </FormControl>
        {isTabsVisible && (
          <div
            style={{
              overflowY: "auto",
              maxHeight: hideChangeView ? "480px" : "500px",
              margin: selectedTab == 0 ? "0px 10px 10px" : "10px 10px 10px",
              height: hideChangeView ? "480px" : "500px",
            }}
            className="scrollBar-visible-year"
          >
            <FormGroup>
              {displayedUsersList
                .filter(
                  (user) =>
                    !(
                      infoEmployee !== "" &&
                      user.numFuncionario === infoEmployee
                    )
                )
                .map((user) => (
                  <FormControlLabel
                    key={uuidv4()}
                    control={
                      <Checkbox
                        checked={selectedUsers.includes(user.numFuncionario)}
                        onChange={() => handleUserChange(user.numFuncionario)}
                        style={{
                          color: selectedUsers.includes(user.numFuncionario)
                            ? selectedUsersColor[user.numFuncionario]
                            : "inherit",
                        }}
                      />
                    }
                    label={user.nomeCurto}
                  />
                ))}
            </FormGroup>
          </div>
        )}
      </div>
    );
  };

  const calendarComponent = () => {
    const calendarProps = {
      localizer,
      events,
      date: dateSelected,
      toolbar: true,
      defaultView,
      setEvents,
      convertToEventsMarkedDays,
      convertToEventsMarkedDaysToApprove,
      settoastText,
      setShowToast,
      isEditable,
      monthClickToChange,
      t,
      views: {
        day: false,
        week: false,
        month: true,
        year: Year,
      },
      max: moment(new Date().setHours(20, 0, 0, 0)).toDate(),
      min: moment(new Date().setHours(8, 0, 0, 0)).toDate(),
      startAccessor: "start",
      endAccessor: "end",
      onNavigate: getDatesFromDays,
      onView: (e) => setDefaultView(e),
      dayPropGetter,
      onDrillDown,
      onRangeChange: rangeChange,
      formats: { eventTimeRangeFormat: () => null },
      messages: { year: "Year" },
      tooltipAccessor: constructTooltip,
      components: {
        event: Event,
        month: { dateHeader: CustomDateHeader },
        toolbar: CustomToolbar,
      },
    };

    if (isEditable) {
      calendarProps.selectable = true;
      calendarProps.singleDaySelection = singleDaySelection;
      calendarProps.setRemoveAll = setRemoveAll;
      calendarProps.setRemoveSomeDays = setRemoveSomeDays;
      calendarProps.userNamePortalRH = userNamePortalRH;
      calendarProps.eventPropGetter = (myEventsList) => {
        const border = myEventsList.color
          ? `2px solid ${myEventsList.color}`
          : "blue";
        const opacity = 0.3;
        const backgroundColor = myEventsList.color
          ? `${myEventsList.color}${Math.floor(opacity * 255).toString(16)}`
          : "blue";

        if (
          myEventsList.type === "ferias" ||
          myEventsList.type === "datasMarcacoes" ||
          myEventsList.type === "datasGozados"
        ) {
          return {
            className: myEventsList.type,
            style: {
              border,
              cursor: "default",
              color: "inherit",
              backgroundColor,
            },
          };
        }

        if (myEventsList.type === "feriasPendentes") {
          return {
            className: `feriasPendentes ${
              myEventsList.parteDia === "1"
                ? "meio-dia1parte"
                : myEventsList.parteDia === "2"
                ? "meio-dia2parte"
                : ""
            } ${myEventsList.toCancel ? "toCancel" : ""}`.trim(),
            style: {
              border: myEventsList.toCancel
                ? "2px solid #b85959"
                : "2px solid rgb(184, 164, 35)",
              cursor: "default",
              color: "inherit",
              backgroundColor: myEventsList.toCancel ? "#F8B4B4" : "#E6CD32",
            },
          };
        }

        if (myEventsList.type === "feriasmarked") {
          return {
            className: "feriasmarked",
            style: {
              border,
              cursor: "default",
              color: "inherit",
              backgroundColor: "transparent",
            },
          };
        }

        return null;
      };
    } else {
      calendarProps.selectable = false;
      calendarProps.handleClickToSHowList = handleClick;
      calendarProps.infoEmployee = infoEmployee;
      calendarProps.infoTypeRequest = infoTypeRequest;
      calendarProps.eventPropGetter = (myEventsList) => {
        const border = myEventsList.color
          ? `2px solid ${myEventsList.color}`
          : "blue";

        if (myEventsList.type === "ferias") {
          const eventos = eventosDoDia(myEventsList.start, events);
          if (eventos.length > 2) {
            return {
              className: "ferias",
              style: {
                border: "0px",
                cursor: "default",
                backgroundColor: "transparent",
              },
            };
          }
          return {
            className: "ferias",
            style: {
              border,
              cursor: "default",
              color: "inherit",
              backgroundColor: "rgb(112, 112, 112/10%)",
            },
          };
        }

        if (myEventsList.type === "feriasmarked") {
          return {
            className: "feriasmarked",
            style: {
              border,
              cursor: "default",
              color: "inherit",
              backgroundColor: "transparent",
            },
          };
        }

        return null;
      };
    }
    return <Calendar {...calendarProps} />;
  };

  const schedulerContrutor = () => {
    return (
      <div key={forceUpdate} style={{ width: "100%" }}>
        <>
          {calendarComponent()}
          <Popover
            open={open}
            onClose={handleClose}
            anchorReference="anchorPosition"
            anchorPosition={anchorEl}
          >
            {isloadingEntrieDetail ? (
              <p style={{ padding: "10px" }}>
                {" "}
                {t("portalrh.workDays.feriasTranslated.loadingDetail")}
              </p>
            ) : (
              Array.isArray(popupEvent) &&
              popupEvent.map((event) =>
                event.type !== "diasAprovar" &&
                event.type !== "diasAprovarCancelar" ? (
                  <div
                    key={event.id}
                    style={{ padding: "10px", cursor: "default" }}
                  >
                    <CreatePopUpEntry event={event} />
                  </div>
                ) : null
              )
            )}
            {!isloadingEntrieDetail && (
              <Stack
                direction="row"
                style={{ placeContent: "center" }}
                alignItems="center"
                spacing={2}
                margin="5px"
              >
                <ButtonBoot id="button_vacations_closeEntrieDetail" className="card-button-red" onClick={handleClose}>
                  {t("portalrh.workDays.close")}
                </ButtonBoot>
              </Stack>
            )}
          </Popover>
        </>
      </div>
    );
  };

  const CreatePopUpEntry = ({ event }) => {
    const style = {
      color: event.color,
      backgroundColor: "rgba(112, 112, 112, 0.09)",
      border: `2px solid ${event.color || "blue"}`,
      fontSize: "x-small",
      fontWeight: "bolder",
      whiteSpace: "nowrap",
      margin: eventEntrieDetail.length > 0 && "10px 0px",
    };

    const textWithMeioDia =
      event.meioDia === "1"
        ? `${event.name} (meio)`
        : `${event.name} (inteiro)`;

    return (
      <>
        {eventEntrieDetail.length > 0
          ? eventEntrieDetail.map((entry, index) => {
              const employeeId = Object.keys(entry)[0];
              const employeeData = entry[employeeId][0];
              const employeeName = entry.nome[0];

              return (
                <p key={index} className="popupP" style={style}>
                  {createEventImageDependingState(employeeData.state)}
                  {employeeName} (
                  {employeeData.meioDia === "1" ? "meio" : "inteiro"})
                </p>
              );
            })
          : event.state && (
              <p className="popupP" style={style}>
                {createEventImageDependingState(event.state)}
                {textWithMeioDia}
              </p>
            )}
      </>
    );
  };

  const constructTooltip = (event) => {
    return event.name;
  };

  const onDrillDown = (slotInfo) => {
    if (!isEditable || slotInfo.getMonth() !== dateSelected.getMonth()) return;

    const eventOnThisDay = events.find((event) =>
      moment(event.start).isSame(slotInfo, "day")
    );

    if (eventOnThisDay) {
      if (eventOnThisDay.type !== "feriasmarked") {
        if (
          ["ferias", "datasMarcacoes", "feriasPendentes"].includes(
            eventOnThisDay.type
          )
        ) {
          setRemoveSomeDays(eventOnThisDay);
        }
      } else {
        setSelectedSlot(slotInfo);
        confirmCheckDay(slotInfo);
      }
    } else {
      setSelectedSlot(slotInfo);
      confirmCheckDay(slotInfo);
    }
  };

  function CustomDateHeader({ label, onDrillDown, isOffRange }) {
    const filteredEvents = events.filter(
      (event) => event.start.getMonth() === dateSelected.getMonth()
    );
    const padNumber = (number) => (number < 10 ? `0${number}` : number);

    const hasEvents = filteredEvents.some((event) => {
      const eventDayString = padNumber(event.start.getDate().toString());
      return event.type !== "feriasmarked" && eventDayString === label;
    });

    const hasEventsMark = filteredEvents.some((event) => {
      const eventDayString = padNumber(event.start.getDate().toString());
      return event.type === "feriasmarked" && eventDayString === label;
    });

    const handleClickOnDrillDown = (e) => {
      onDrillDown(e);
    };

    return (
      <div
        onClick={(e) => handleClickOnDrillDown(e)}
        className="custom-date-header"
      >
        <div className="dh-item header-left">
          {!isOffRange && !hasEvents && isEditable ? (
            hasEventsMark ? (
              <MdOutlineRemoveCircleOutline color="#b1b1b1" />
            ) : (
              <GoPlusCircle color="#b1b1b1" />
            )
          ) : null}
        </div>
        <div className="dh-item header-right">
          <a>{label}</a>
        </div>
      </div>
    );
  }

  const handleClick = (event, selectedEvent) => {
    if (selectedEvent[0].entries !== undefined) {
      const payload = {
        diaInicial: moment(selectedEvent[0].start).format("YYYY-MM-DD"),
        diaFinal: moment(selectedEvent[0].end).format("YYYY-MM-DD"),
        lepNum: selectedUsers,
      };
      dispatch(getEventEntrieDetail(payload));
    }
    const rect = event.currentTarget.getBoundingClientRect();
    const top = rect.top - rect.height;

    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";

    setAnchorEl({ top: top, left: rect.left });
    setPopupEvent(selectedEvent);
  };

  const monthClickToChange = (date) => {
    setDefaultView("month");
    setForceUpdate((prevKey) => prevKey + 1);
    setDateSelected(new Date(date));
    changeViewAndCallGetAllFerias("month");
  };

  const handleClose = () => {
    setAnchorEl(null);
    setPopupEvent(null);
    document.body.style.overflow = "";
    document.body.style.position = "";
    dispatch(setEventEntrieDetail([]));
  };

  function Event({ event }) {
    const commonStyle = {
      display: "inline-flex",
      marginTop: "2px",
      color:
        (event.type === "folgas" || event.type === "feriados") && event.color,
    };

    if (event.type === "feriasmarked") {
      return (
        <span className="eventSpan" style={commonStyle}>
          {event.title}
        </span>
      );
    }

    if (event.type === "intervals" || event.type === "ferias") {
      const eventos = eventosDoDia(event.start, events);
      if (eventos.length > 2) {
        return (
          <div
            onClick={(e) => handleClick(e, eventos)}
            style={{ textAlign: "center" }}
            title={`${eventos.length} ${t("portalrh.workDays.eventos")}`}
          >
            <span
              className="eventSpan"
              style={{
                ...commonStyle,
                backgroundColor:
                  event.type === "intervals"
                    ? "rgba(51,5,141, 0.4)"
                    : "rgba(237,108,2, 0.4)",
                padding: "5px",
                width: "40px",
                borderRadius: "20px",
                fontSize: "small",
                border: `2px solid ${
                  event.type === "intervals" ? "rgb(51,5,141)" : "#ED6C02"
                }`,
                color: event.type === "intervals" ? "rgb(51,5,141)" : "#ED6C02",
              }}
            >
              + {eventos.length}
            </span>
          </div>
        );
      }
      return (
        <div>
          {createEventImageDependingState(event.state)}
          <span
            className="eventSpan"
            style={{
              ...commonStyle,
              color: event.type === "ferias" ? "dimgrey" : "inherit",
            }}
          >
            {event.title}
          </span>
        </div>
      );
    }

    return (
      <span className="eventSpan" style={commonStyle}>
        {event.title}
      </span>
    );
  }

  const createEventImageDependingState = (state) => {
    const styles = {
      0: { color: "goldenrod", icon: FaClock },
      1: { color: "goldenrod", icon: FaClock },
      2: { color: "red", icon: FaMinusCircle },
      3: { color: "green", icon: FaCheckCircle },
      4: { color: "red", icon: FaTimesCircle },
      5: { color: "green", icon: FaEye },
    };

    const { color, icon: Icon } = styles[state] || {};
    return color && Icon ? (
      <Icon
        style={{
          fontSize: "small",
          alignSelf: "center",
          marginRight: "5px",
          color,
        }}
      />
    ) : null;
  };

  const ColorButtonArrow = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(grey[600]),
    backgroundColor: grey[600],
    "&:hover": {
      backgroundColor: grey[500],
    },
  }));

  const handleSendDays = () => {
    const eventsDays = events.filter(
      (event) => event.type === "feriasmarked" || event.type === "intervals"
    );
    if (eventsDays.length < 1) return;
    setEventsTemp(eventsDays);
    setShowModalWithDaysMarked(true);
  };

  const removeDayFromEvents = (day) => {
    const updatedEvents = events.filter((event) => event.id !== day.id);
    setEvents(updatedEvents);
  };

  const handleSaveWorkDays = () => {
    const finalPayload = getEventsToCreate(eventsTemp);

    if (userNamePortalRH) {
      const payload = {
        dates: finalPayload,
        userId: userNamePortalRH.id,
        type: "Novo",
      };
      dispatch(postMarcacaoFerias(payload));
      setEventsTemp([]);
      handleRestartMarkup();
      setShowModalWithDaysMarked(false);
    }
  };

  const handleSaveWorkDaysConfirm = () => {
    const eventsDays = events.filter((event) => event.type === "feriasmarked");

    const dates = eventsDays.map((event) => {
      const eventDates = [new Date(event.start).toISOString().split("T")[0]];
      if (event.intervals) {
        event.intervals.forEach((interval) => {
          eventDates.push(new Date(interval).toISOString().split("T")[0]);
        });
      }
      return { dates: eventDates };
    });

    if (userNamePortalRH) {
      const payload = {
        anoAnterior: false,
        dates,
        userId: userNamePortalRH.id,
      };
      setShowModalWithDaysMarkedConfirm(false);
      setShowModalWithDaysMarked(false);
    }
  };

  const handleCheckboxChange = (day, type) => {
    setEvents((prevEvents) => {
      return prevEvents.map((eventDay) => {
        if (eventDay.id === day.id) {
          return {
            ...eventDay,
            checked: type === "diaInteiro",
            checkedHalfDay: type !== "diaInteiro",
          };
        }
        return eventDay;
      });
    });
  };

  const handleRemoveDays = () => {
    setConfirmRemoveDaysSelected(true);
  };

  const handleConfirmRemoveDays = (eventsDays, onHide) => {
    if (removeSomeDays.type !== "datasMarcacoes") {
      const payload = {
        ped_id: removeSomeDays.idToSelect,
        state: 2,
        username: userNamePortalRH?.username,
      };
      dispatch(approveDeleteRemoveMarcacaoFerias(payload));
      const updatedEvents = events.filter(
        (event) => event.idToSelect !== removeSomeDays.idToSelect
      );
      setEvents(updatedEvents);
      onHide();
    } else {
      const arrayDestino = eventsDays
        .filter((eventDay) => eventDay.daytoRemove)
        .map((eventDay) => ({
          dataInicio: moment(eventDay.start).format("YYYY-MM-DD"),
          dataFim: moment(eventDay.end).format("YYYY-MM-DD"),
          numFuncionario: userNamePortalRH?.funcionarioNum,
          idpedido: eventDay.idToSelect,
        }));

      if (arrayDestino.length > 0) {
        const payloadOtherRequest = {
          usrId: userNamePortalRH?.id,
          entidade: userNamePortalRH?.codEntidade,
          numFunc: userNamePortalRH?.funcionarioNum,
          ano: loadNewDateSelected.getFullYear(),
        };
        dispatch(cancelDayOffRequest(arrayDestino, payloadOtherRequest));
        setShowModalWithDaysToRemove(false);
        setDateToCompare(undefined);
        setRemoveSomeDays({});
        setConfirmRemoveDaysSelected(false);
      }
    }
  };

  const updateEventState = (eventId, updatedProperties) => {
    const updatedEvents = eventsTemp.map((event) =>
      event.id === eventId ? { ...event, ...updatedProperties } : event
    );
    setEventsTemp(updatedEvents);
  };

  const removeDayFromEventsTemp = (day) => {
    const dayId = day.id;
    const dayIntervals = day.intervals
      ? day.intervals.map(
          (interval) => new Date(interval).toISOString().split("T")[0]
        )
      : [];

    const updatedEvents = eventsTemp.filter((event) => {
      const eventDate = new Date(event.start).toISOString().split("T")[0];
      if (event.type === "intervals") {
        return !(event.id === dayId || dayIntervals.includes(eventDate));
      } else {
        return event.id !== dayId;
      }
    });
    setEventsTemp(updatedEvents);
  };

  const handleExport = (type) => {
    if (type === "criteria") {
      setShowModalCriteria(true);
    } else {
      const filteredDiasMarcados = marcacaoFerias.diasmarcadosTeam.filter(
        (item) => {
          return (
            selectedUsers.includes(item.userId) &&
            (type === "screen"
              ? new Date(item.data).getMonth() === dateSelected.getMonth()
              : new Date(item.data).getFullYear() ===
                dateSelected.getFullYear())
          );
        }
      );

      const payload = {
        type,
        list: filteredDiasMarcados,
        monthName: moment(dateSelected).format("MMMM"),
        yearDate: moment(dateSelected).format("YYYY"),
      };
      sendExportData(payload);
    }
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleSendCriteriaData = () => {
    if (Object.keys(gruposTrabalhoRemoto).length > 0) {
      let ids;
      if (criteriaGroup === "") {
        ids = gruposTrabalhoRemoto.flatMap((group) =>
          group.userList.map((user) => user.id)
        );
      } else {
        const selectedGroupCriteria = gruposTrabalhoRemoto.find(
          (group) => group.grupo.id === criteriaGroup
        );
        ids = selectedGroupCriteria.userList.map((user) => user.id);
      }
      if (startAt === "" || endAt === "") {
        setOpenExportError(true);
        return;
      }
      const payload = {
        type: "criteria",
        dataInicio: formatDate(new Date(startAt)),
        dataFim: formatDate(new Date(endAt)),
        ids,
      };
      sendExportData(payload);
    }
  };

  const changeViewAndCallGetAllFerias = (view) => {
    if (isEditable) return;
    const events =
      selectedUsers.length > 0
        ? filterWorkdaysByUsers(view)
        : [...getDiasParaAprovarEvents(), ...emplyeeEvents];
    setEvents(events || []);
  };

  const sendExportData = (payload) => {
    handleModalCloseCriteria();
  };

  const handleSingleDaySelection = (event, newAlignment) => {
    if (newAlignment === null) return;
    setSingleDaySelection(newAlignment);
  };

  const handleRestartMarkup = () => {
    const filteredEvents =
      events &&
      events.filter(
        (event) =>
          event.type !== "feriasmarked" &&
          event.type !== "hover" &&
          event.type !== "intervals"
      );
    setEvents(filteredEvents || []);
    setRemoveAll(false);
  };

  class CustomToolbar extends React.Component {
    navigate = (action) => {
      this.props.onNavigate(action);
    };

    changeView = (view) => {
      this.props.onView(view);
    };

    renderExportButton = () => (
      <DropDownBoot>
        <DropDownBoot.Toggle
          id="dropdown-basic"
          style={{
            backgroundColor: "#4484f4",
            borderColor: "#4484f4",
            color: "white",
          }}
        >
          <FaFileExport className="me-2" />
          {t("portalrh.workDays.export.btn")}
        </DropDownBoot.Toggle>
        <DropDownBoot.Menu>
          <DropDownBoot.Item onClick={() => handleExport("screen")}>
            {t("portalrh.workDays.export.item1")}
          </DropDownBoot.Item>
          <DropDownBoot.Item onClick={() => handleExport("year")}>
            {t("portalrh.workDays.export.item2")}
          </DropDownBoot.Item>
          <DropDownBoot.Item onClick={() => handleExport("criteria")}>
            {t("portalrh.workDays.export.item3")}
          </DropDownBoot.Item>
        </DropDownBoot.Menu>
      </DropDownBoot>
    );

    renderToggleButtonGroup = () => (
      <ToggleButtonGroup
        value={defaultView}
        exclusive
        onChange={(event, value) => {
          value !== null && this.changeView(value);
          changeViewAndCallGetAllFerias(value);
        }}
        aria-label="calendar view"
      >
        <ToggleButton value="month" aria-label="month">
          <FaCalendarDay /> {t("portalrh.workDays.mes")}
        </ToggleButton>
        <ToggleButton value="year" aria-label="year">
          <FaCalendarAlt /> {t("portalrh.workDays.ano")}
        </ToggleButton>
      </ToggleButtonGroup>
    );

    renderSingleDaySelection = () => (
      <>
        <InputLabel id="typeMarkup">Tipo de Marcação</InputLabel>
        <ToggleButtonGroup
          value={singleDaySelection}
          exclusive
          onChange={handleSingleDaySelection}
          aria-label="text alignment"
        >
          <ToggleButton value="single" aria-label="Dia">
            <CgCalendarToday /> Dia
          </ToggleButton>
          <ToggleButton
            value="interval"
            aria-label="Intervalo"
            disabled={blockIntervalSelections}
          >
            <HiMiniCalendarDays /> Intervalo
          </ToggleButton>
        </ToggleButtonGroup>
      </>
    );

    render() {
      const {
        localizer: { messages },
        label,
      } = this.props;

      return (
        <div className="rbc-toolbar">
          <Row className="mb-3 w-100">
            {!isEditable && exportBtn && (
              <Col xs="12" md="6" className="p-0 mb-2 mb-md-0">
                {this.renderExportButton()}
              </Col>
            )}
            <Col
              xs="12"
              md={exportBtn ? "6" : !hideChangeView ? "6" : "12"}
              className={`text-end d-flex justify-content-end gap-3 align-items-baseline col-lg-${
                isEditable ? 6 : 12
              } col-md-12 col-sm-12 ${hideChangeView ? "text-end" : ""}`}
            >
              <Row className="w-100">
                {!isMobile && (
                  <Col
                    xs="12"
                    lg={!hideChangeView ? "5" : "4"}
                    md={!hideChangeView ? "5" : "4"}
                    className="text-end p-0 text-md-start"
                  >
                    {this.renderToggleButtonGroup()}
                  </Col>
                )}
                <Col
                  xs="12"
                  lg={!hideChangeView ? "7" : "8"}
                  md={!hideChangeView ? "7" : "8"}
                  className={`align-items-center p-0 ${
                    isMobile
                      ? "mb-3 d-flex justify-content-center"
                      : "justify-content-start"
                  }`}
                >
                  <ColorButtonArrow
                    size="small"
                    variant="text"
                    startIcon={<FaAngleDoubleLeft />}
                    onClick={this.navigate.bind(null, navigate.PREVIOUS)}
                  />
                  <span
                    className="rbc-toolbar-label mx-2"
                    style={{ maxWidth: "15%" }}
                    onClick={() => {
                      defaultView !== "year" && setShowCalendar(!showCalendar);
                    }}
                  >
                    {label}
                  </span>
                  <ColorButtonArrow
                    size="small"
                    variant="text"
                    startIcon={<FaAngleDoubleRight />}
                    onClick={this.navigate.bind(null, navigate.NEXT)}
                  />
                  {showCalendar && (
                    <CalendarReact
                      className="reactCalendarClass"
                      onChange={handleDateChange}
                      value={dateSelected}
                      maxDetail="year"
                      minDetail="decade"
                      locale={selectedLocale || "en"}
                    />
                  )}
                </Col>
              </Row>
            </Col>
            {!isMobile && isEditable && (
              <Col
                lg="6"
                md="12"
                sm="12"
                className="text-end"
                style={{
                  padding: "0px",
                  display: "inline-flex",
                  justifyContent: "right",
                  gap: "1rem",
                  alignItems: "baseline",
                }}
              >
                {!hideChangeView &&
                  defaultView !== "month" &&
                  this.renderSingleDaySelection()}
                {isEditable && (
                  <Stack
                    direction="row"
                    style={{ placeContent: "center" }}
                    alignItems="center"
                    spacing={2}
                    margin="5px"
                  >
                    <ButtonBoot
                      id="button_vacations_newMark"
                      className="card-button"
                      onClick={handleSendDays}
                      style={{ color: "white" }}
                      disabled={
                        events.filter(
                          (event) =>
                            event.type === "feriasmarked" ||
                            event.type === "intervals"
                        ).length <= 0
                      }
                    >
                      {t("portalrh.workDays.newMark")}
                    </ButtonBoot>
                    {removeall && (
                      <ButtonBoot
                        id="button_vacations_cancelDays"
                        className="card-button-red active"
                        onClick={handleRestartMarkup}
                      >
                        {t("portalrh.workDays.cancel")}
                      </ButtonBoot>
                    )}
                  </Stack>
                )}
              </Col>
            )}
            {isMobile && (
              <Col
                lg="6"
                md="12"
                sm="12"
                className="text-end d-flex p-0 justify-content-end gap-3 align-items-flex-start"
              >
                {!hideChangeView && defaultView !== "month" && (
                  <Col
                    className={`justify-content-end ${isMobile ? "mb-3" : ""}`}
                    style={{ display: "contents" }}
                  >
                    {this.renderSingleDaySelection()}
                  </Col>
                )}
              </Col>
            )}
            {isEditable && isMobile && (
              <Row className="g-2 align-items-center justify-content-center">
                <Col
                  className={`d-flex ${
                    isMobile ? "justify-content-center" : "justify-content-end"
                  }`}
                  style={{ gap: "1.2em", marginTop: "0.5em" }}
                >
                  <ButtonBoot
                    id="button_vacations_newMark_mobile"
                    className="card-button"
                    onClick={handleSendDays}
                    style={{ color: "white" }}
                    disabled={
                      events.filter(
                        (event) =>
                          event.type === "feriasmarked" ||
                          event.type === "intervals"
                      ).length <= 0
                    }
                  >
                    {t("portalrh.workDays.newMark")}
                  </ButtonBoot>
                  {removeall && (
                    <ButtonBoot
                      id="button_vacations_cancelDays_mobile"
                      className="card-button-red active"
                      onClick={handleRestartMarkup}
                    >
                      {t("portalrh.workDays.cancel")}
                    </ButtonBoot>
                  )}
                </Col>
              </Row>
            )}
          </Row>
          {isEditable && (
            <Row className="w-100 mb-3">
              <Col xs="12" className="p-0">
                <Situation />
              </Col>
            </Row>
          )}
        </div>
      );
    }
  }

  const syncEventsWithTemp = () => {
    const updatedEvents = events.filter((event) =>
      event.type === "intervals" || event.type === "feriasmarked"
        ? eventsTemp.some((tempEvent) => tempEvent.id === event.id)
        : true
    );

    eventsTemp.forEach((tempEvent) => {
      const eventIndex = updatedEvents.findIndex(
        (event) => event.id === tempEvent.id
      );

      if (eventIndex !== -1) {
        updatedEvents[eventIndex] = { ...tempEvent };
      } else {
        updatedEvents.push({ ...tempEvent });
      }
    });
    setEvents(updatedEvents);
  };

  const handleModalClose = () => {
    syncEventsWithTemp();
    setShowModalWithDaysMarked(false);
    setShowModalWithDaysMarkedConfirm(false);
  };

  const handleModalCloseDaysToRemove = () => {
    setShowModalWithDaysToRemove(false);
    setDateToCompare(undefined);
    setRemoveSomeDays({});
    setConfirmRemoveDaysSelected(false);
    const updatedEvents = events.map((event) => ({
      ...event,
      daytoRemove: event.daytoRemove != null,
    }));
    setEvents(updatedEvents);
  };

  const handleCloseExport = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(setExportVals(""));
    setOpenExport(false);
    setmessageTranslated("");
  };

  const handleCloseExportError = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenExportError(false);
  };

  useEffect(() => {
    if (showModalWithDaysMarked && eventsTemp.length < 1) {
      setShowModalWithDaysMarked(false);
    }
  }, [eventsTemp]);

  return (
    <>
      <SpinnerNew open={isLoadingExport || isLoadingMarcacaoFerias} />
      <AlertsComponent
        openExport={openExport}
        handleCloseExport={handleCloseExport}
        messageTranslated={messageTranslated}
        openExportError={openExportError}
        handleCloseExportError={handleCloseExportError}
        showToast={showToast}
        handleCloseShowToast={handleCloseShowToast}
        handleCloseShowToastMSG={handleCloseShowToastMSG}
        toastText={toastText}
        showToastMSG={showToastMSG}
      />
      <>
        {showCalendarAndTable && (
          <div style={{ padding: isEditable && hideChangeView ? "10px" : "" }}>
            <Row>
              {!isEditable && Object.keys(gruposTrabalhoRemoto).length > 0 && (
                <Col lg="4" md="4" sm="12" style={{ padding: 0 }}>
                  {listUsersByGroupConstructor()}
                </Col>
              )}
              <Col
                lg={!isEditable ? "8" : "12"}
                md={!isEditable ? "8" : "12"}
                sm="12"
                style={{ padding: 0 }}
              >
                {selectedLocale && schedulerContrutor()}
              </Col>
            </Row>
          </div>
        )}
      </>
      <Modals
        showModalWithDaysMarkedConfirm={showModalWithDaysMarkedConfirm}
        showModalCheckDays={showModalCheckDays}
        handleModalCloseCheckDays={handleModalCloseCheckDays}
        showModalCriteria={showModalCriteria}
        handleModalCloseCriteria={handleModalCloseCriteria}
        showModalWithDaysToRemove={showModalWithDaysToRemove}
        handleModalCloseDaysToRemove={handleModalCloseDaysToRemove}
        showModalWithDaysMarked={showModalWithDaysMarked}
        handleModalClose={handleModalClose}
        handleCheckboxChange={handleCheckboxChange}
        handleSaveWorkDays={handleSaveWorkDays}
        isDisabled={isDisabled(eventsTemp, marcacaoFeriasCalendario)}
        eventsTemp={eventsTemp}
        selectedLocale={selectedLocale}
        marcacaoFeriasCalendario={marcacaoFeriasCalendario}
        marcacaoFeriasmsg={marcacaoFeriasmsg}
        events={events}
        removeDayFromEvents={removeDayFromEvents}
        updateEventState={updateEventState}
        removeDayFromEventsTemp={removeDayFromEventsTemp}
        handleSaveWorkDaysConfirm={handleSaveWorkDaysConfirm}
        confirmRemoveDaysSelected={confirmRemoveDaysSelected}
        setConfirmRemoveDaysSelected={setConfirmRemoveDaysSelected}
        handleRemoveDays={handleRemoveDays}
        handleConfirmRemoveDays={handleConfirmRemoveDays}
        gruposTrabalhoRemoto={gruposTrabalhoRemoto}
        criteriaGroup={criteriaGroup}
        setCriteriaGroup={setCriteriaGroup}
        startAt={startAt}
        setStartAt={setStartAt}
        endAt={endAt}
        setEndAt={setEndAt}
        handleSendCriteriaData={handleSendCriteriaData}
        setShowModalWithDaysMarked={setShowModalWithDaysMarked}
        setShowModalWithDaysMarkedConfirm={setShowModalWithDaysMarkedConfirm}
      />
      <ExportTable
        componentRef={componentRef}
        calendarData={calendarData}
        selectedGroup={selectedGroup}
        gruposTrabalhoRemoto={gruposTrabalhoRemoto}
        loadNewDateSelected={loadNewDateSelected}
        tableType={tableType}
      />
    </>
  );
};

export default withNamespaces()(SchedulerComponent);
